import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  IAnalyticsDownloadLinks,
  IChartBox,
} from '../../../../types/analytics';
import { Label } from '../../../common/Label/Label';
import styles from '../Style/AnalyticsPanel.module.scss';

export const ChartBox: React.FC<IChartBox> = (props) => {
  const {
    plot,
    link,
    customLink,
    height,
    showDisclaimer,
    limitation,
    showAxis,
    xAxis,
    yAxis,
  } = props;

  const [margin, setMargin] = useState('');

  useEffect(() => {
    if (height !== 'auto') {
      setMargin('30px');
    } else {
      setMargin('0px');
    }
  }, [height]);

  return (
    <div className={styles.chartWrapperContent}>
      {plot && showAxis && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={styles.xAxis} style={{ textAlign: 'center' }}>
            {xAxis?.Name} <span>[{xAxis?.Unit}]</span>
          </div>
          <div style={{ display: 'flex' }}>
            <div className={styles.yAxis} style={{ alignSelf: 'center' }}>
              {yAxis?.Name}
              <span>[{yAxis?.Unit}]</span>
            </div>
            <div
              style={{
                height,
                width: '100%',
                marginRight: margin,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {plot}
            </div>
          </div>
        </div>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {customLink && (
          <div style={{ alignSelf: 'flex-end' }}>{customLink}</div>
        )}
        {link && <AnalyticsDownloadLinks links={link} />}
        {plot && !showAxis && (
          <div
            style={{
              height,
              width: '100%',
              marginRight: margin,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {plot}
          </div>
        )}
      </div>
      {showDisclaimer && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
          }}
        >
          <Label label={<h3> {'Disclaimer'} </h3>} />
          <Label
            label={
              'Data and derived parameters should not be used for detailed design'
            }
          />
        </div>
      )}
      {limitation && limitation}
    </div>
  );
};

export const AnalyticsDownloadLinks: React.FC<IAnalyticsDownloadLinks> = (
  props
) => {
  const { links } = props;
  return (
    <div className={styles.linkContainer}>
      {links &&
        links.map((link: string, index: number) => {
          const fileType = link.split('.');
          const typeName = fileType[fileType.length - 1];
          return link && fileType.length > 0 ? (
            <Button
              type='link'
              key={index}
              className={styles.buttonLink}
              href={link}
              data-testid='Chart_Download_File_Button'
            >
              {`Download as ${
                typeName === 'txt' ? 'ASCII' : typeName.toUpperCase()
              }`}
            </Button>
          ) : null;
        })}
    </div>
  );
};
